//Liquid variable reStockVariant is located at sections/product.liquid

// Function to check if any reStockVariant title matches the value and return the reStockDate
function getReStockDate(value) {
    var matchedVariant = reStockVariants.find(function(variant) {
        return variant.title.toLowerCase() === value.toLowerCase(); 
    });
    //return matchedVariant ? matchedVariant.reStockDate : null; // Return reStockDate if match found, else null
    return matchedVariant;
}
  
document.addEventListener('DOMContentLoaded', function() {
  const selectElement = document.querySelector('select#SingleOptionSelector-0');

  // Retrieve the current value and log it to the console
  const currentValue = selectElement.value.replace(/["']/g, '');
  //console.log('--------------------------------------');
  //console.log('Current value:', currentValue);

  const inventoryElement = document.querySelector('#variant-inventory');
  const restockElement = document.querySelector('#variant-inventory-restock');
  const inStockSpan = document.createElement('span');
  inStockSpan.className = 'in-stock';
  
  // Check if there's a match with the current value and retrieve reStockDate
  var currentReStockDate = getReStockDate(currentValue);
  if (currentReStockDate) {
    //console.log('Match found for current value:', currentValue);
    //console.log('Restock Date:', currentReStockDate.reStockDate);

    if (currentReStockDate.stockVariant <= 0 || currentReStockDate.stockManagement == null || currentReStockDate.stockManagement == '') {
      inStockSpan.textContent = 'ON ORDER - Ships By ' + currentReStockDate.reStockDate;
      restockElement.appendChild(inStockSpan);

      if (inventoryElement) {
        restockElement.style.display = 'block';
        inventoryElement.style.display = 'none';
      }

      if (currentReStockDate.stockManagement == null || currentReStockDate.stockManagement == '') {
        //console.log('Inventory Management is null');
      }
    } else {
      if (currentReStockDate.stockManagement == null || currentReStockDate.stockManagement == '') {
        //console.log('Inventory Management is null');
      }
      console.log('Has stock available for current value:', currentValue);
      if (inventoryElement) {
        restockElement.style.display = 'none';
        inventoryElement.style.display = 'block';
      }
    }
    
  } else {
    //console.log('No match found for current value:', currentValue);
    if (inventoryElement) {
      restockElement.style.display = 'none';
      inventoryElement.style.display = 'block';
    }
  }
  
  // Listen for changes to the select element and log the new value to the console
  selectElement.addEventListener('input', () => {
    const newValue = selectElement.value.replace(/["']/g, '');
    //console.log('--------------------------------------');
    //console.log('New value:', newValue);

    // Check if there's a match with the new value and retrieve reStockDate
    var newReStockDate = getReStockDate(newValue);
    if (newReStockDate) {
      //console.log('Match found for new value:', newValue);
      //console.log('Restock Date:', newReStockDate.reStockDate);

      if (newReStockDate.stockVariant <= 0 || newReStockDate.stockManagement == null || newReStockDate.stockManagement == '') {
        inStockSpan.textContent = 'ON ORDER - Ships By ' + newReStockDate.reStockDate;
        restockElement.appendChild(inStockSpan);
  
        if (inventoryElement) {
          restockElement.style.display = 'block';
          inventoryElement.style.display = 'none';
        }

        if (newReStockDate.stockManagement == null || newReStockDate.stockManagement == '') {
          //console.log('Inventory Management is null');
        }
      } else {
        if (newReStockDate.stockManagement == null || newReStockDate.stockManagement == '') {
          //console.log('Inventory Management is null');
        }
        //console.log('Has stock available for new value:', newValue);
        restockElement.style.display = 'none';
        inventoryElement.style.display = 'block';
      }
    } else {
      //console.log('No match found for new value:', newValue);
      if (inventoryElement) {
        restockElement.style.display = 'none';
        inventoryElement.style.display = 'block';
      }
    }
  });
});